var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{attrs:{"title":"Selecting Values"}},[_c('div',[_c('selecting-values-default'),_c('selecting-values-single-multiple-selection'),_c('selecting-values-tagging')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }